export default "__VITE_PUBLIC_ASSET__dfb05455__"